import MetricCard from '../../components/MetricCard';
import { formatDuration, formatNumber, pctChange } from '../../lib/format';
import type { FunnelResponse } from '../../types';

export default function CallsStats({ funnel }: { funnel: FunnelResponse }) {
  const cur = funnel.current ?? {};
  const prev = funnel.previous ?? {};

  const totalCalls = Number(cur.totalCalls) || 0;
  const answered = Number(cur.answered) || 0;
  const answerRate = answered > 0 && totalCalls > 0 ? Math.round((answered / totalCalls) * 100) : 0;
  const qualityLeads = Number(cur.qualityLeads) || 0;
  const assessments = Number(cur.assessmentsBooked) || 0;
  const interviews = Number(cur.interviewsScheduled) || 0;
  const avgDur = Number(cur.avgDuration) || 0;

  const prevTotal = Number(prev.totalCalls) || 0;
  const prevAnswered = Number(prev.answered) || 0;
  const prevAnswerRate =
    prevAnswered > 0 && prevTotal > 0 ? Math.round((prevAnswered / prevTotal) * 100) : 0;

  return (
    <div className="metrics-row-5" style={{ gridTemplateColumns: 'repeat(6, 1fr)' }}>
      <MetricCard
        label="Total Calls"
        value={formatNumber(totalCalls)}
        change={pctChange(totalCalls, prevTotal)}
      />
      <MetricCard
        label="Answer Rate"
        value={`${answerRate}%`}
        change={pctChange(answerRate, prevAnswerRate)}
      />
      <MetricCard label="Quality Leads" value={formatNumber(qualityLeads)} />
      <MetricCard label="Assessments Booked" value={formatNumber(assessments)} />
      <MetricCard label="Interviews Scheduled" value={formatNumber(interviews)} />
      <MetricCard label="Avg Duration" value={formatDuration(avgDur)} />
    </div>
  );
}
